import React from 'react';
import { Link } from 'react-router-dom';

const Categories = (props) => {
    if (props.user != null && (parseInt(props.user.uth_type) === 5 || parseInt(props.user.uth_type) === 6)) {
        return (
            <div className="categories-container">
                <div className="categories-row">
                    <div className="category">
                        <Link to="/product/7"><div className="image apparel"></div></Link>
                        <div className="title">
                            <div className="name">Adult Apparel</div>
                            <div className="button-container">
                                <Link to="/product/7"><button>Select</button></Link>
                            </div>
                        </div>
                    </div>
                    <div className="category">
                        <Link to="/department/8/377"><div className="image promotional"></div></Link>
                        <div className="title">
                            <div className="name">Promotional</div>
                            <div className="button-container">
                                <Link to="/department/8/377"><button>Select</button></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else if (props.user != null && parseInt(props.user.uth_type) === 4) {
        return (
            <div className="categories-container">
                <div className="categories-row">
                    <div className="category">
                        <Link to="/product/14"><div className="image my-uthealth-new-august2023"></div></Link>
                        <div className="title">
                            <div className="name">MyUTHealth Houston</div>
                            <div className="button-container">
                                <Link to="/product/14"><button>Select</button></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="categories-container">
            <div className="categories-row">
                <div className="category">
                    <Link to="/product/9"><div className="image cards"></div></Link>
                    <div className="title">
                        <div className="name">Business Cards</div>
                        <div className="button-container">
                            <Link to="/product/9"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/product/10"><div className="image letterheads"></div></Link>
                    <div className="title">
                        <div className="name">Letterheads</div>
                        <div className="button-container">
                            <Link to="/product/10"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/product/11"><div className="image envelopes"></div></Link>
                    <div className="title">
                        <div className="name">Envelopes</div>
                        <div className="button-container">
                            <Link to="/product/11"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/product/12"><div className="image notecards"></div></Link>
                    <div className="title">
                        <div className="name">Thank You Cards and Envelopes</div>
                        <div className="button-container">
                            <Link to="/product/12"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="categories-row">
                <div className="category">
                    <Link to="/product/20"><div className="image pocket-cards"></div></Link>
                    <div className="title">
                        <div className="name">Pocket Cards</div>
                        <div className="button-container">
                            <Link to="/product/20"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/product/7"><div className="image apparel"></div></Link>
                    <div className="title">
                        <div className="name">Adult Apparel</div>
                        <div className="button-container">
                            <Link to="/product/7"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/department/8/377"><div className="image promotional"></div></Link>
                    <div className="title">
                        <div className="name">Promotional</div>
                        <div className="button-container">
                            <Link to="/department/8/377"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/product/14"><div className="image my-uthealth-new-august2023"></div></Link>
                    <div className="title">
                        <div className="name">MyUTHealth Houston</div>
                        <div className="button-container">
                            <Link to="/product/14"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Categories;
